<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('form_placeholder_fabric_search') || '面料编号/名称/成分 搜索...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('btn_advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
      <b-col cols="4" class="text-right">
        <el-button type="primary" size="small" @click="confirm">
          {{ $l('btn_confirm_select') || '确定选择' }}
        </el-button>
        <el-button size="small" @click="cancel">{{ $l('btn_cancel') || '取消' }}</el-button>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('dialog_title_advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      append-to-body
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        label-position="left"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabric_no') || '面料编号'">
              <el-input
                v-model.trim="form.fabricNo"
                :placeholder="$l('form_placeholder_input') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabric_name') || '面料名称'">
              <el-input
                v-model.trim="form.fabricName"
                :placeholder="$l('form_placeholder_input') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabric_name_en') || '面料英文名称'">
              <el-input
                v-model.trim="form.fabricNameEn"
                :placeholder="$l('form_placeholder_input') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabric_content') || '面料成分'">
              <el-input
                v-model.trim="form.fabricContent"
                :placeholder="$l('form_placeholder_input') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabric_content_en') || '面料英文成分'">
              <el-input
                v-model.trim="form.fabricContentEn"
                :placeholder="$l('form_placeholder_input') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_agent') || '业务开发'">
              <dict-select
                clearable
                v-model="form.fabricAgentCode"
                :placeholder="$l('form_placeholder_select') || '请选择...'"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_supplier') || '供应商'">
              <dict-select
                v-model="form.supCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('form_placeholder_select') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="resetForm">
          {{ $l('btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  fabricStatusList: ['Y'],
  fabricNo: '',
  fabricName: '',
  fabricNameEn: '',
  fabricContent: '',
  fabricContentEn: '',
  fabricAgentCode: '',
  supCode: '',
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    resetForm() {
      this.form = { ...initForm }
    },
    reset() {
      this.form = { ...initForm }
      this.query()
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.search-form {
  margin-bottom: 12px;
}
</style>

